import { adaptiveFontSize, getMobileMaxColumnWidth } from './helpers'

const avatarKnownHeight = (parent, config) => {
    const { banner, name } = parent
    const { displayBanner } = config
    const height = name.height + (displayBanner ? banner.height : 0)
    return height
}

export const DESKTOP_AVATAR_STYLES = {
    sm: {
        default: {
            seeAll: {
                fontSize: 15,
            },
            utilities: {
                iconSize: 0.6,
                avatarIconSize: 0.8,
            },
            title: {
                fontSize: 15.5,
            },
            column: {
                maxWidth: 152,
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 7,
                    offsetX: 4,
                    offsetY: 4,
                },
                newMissMFC: {
                    fontSize: 7,
                    margin: 3,
                },
                priorMissMFC: {
                    altHeight: 14,
                    altWidth: 14,
                    height: 10,
                    width: 10,
                    altMargin: '1px 2px 2px 0',
                    margin: '1px 2px 2px 0',
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'viewers per minute',
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                    text: 'MFC',
                },
                minimumWidth: 125,
                iconSize: 0.5,
                fontSize: 9,
                height: 20,
            },
            menu: {},
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 9 }),
                fontSizeMinimum: 7.7,
                height: 18,
            },
            _knownHeight: avatarKnownHeight,
        },
    },
    md: {
        default: {
            seeAll: {
                fontSize: 16,
            },
            utilities: {
                iconSize: 0.7,
                avatarIconSize: 0.9,
            },
            title: {
                fontSize: 17,
            },
            column: {
                maxWidth: 200,
            },
            badge: {
                status: {
                    iconSize: 0.6,
                    fontSize: 8,
                    offsetX: 5,
                    offsetY: 5,
                },
                newMissMFC: {
                    fontSize: 8,
                    margin: 3,
                },
                priorMissMFC: {
                    altHeight: 16,
                    altWidth: 16,
                    height: 11,
                    width: 12,
                    altMargin: '1px 2px 2px 0',
                    margin: '1px 2px 2px 0',
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                minimumWidth: 145,
                iconSize: 0.55,
                fontSize: 9.4,
                height: 22,
            },
            menu: {},
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 11 }),
                fontSizeMinimum: 10,
                height: 24,
            },
            _knownHeight: avatarKnownHeight,
        },
    },
    lg: {
        default: {
            seeAll: {
                fontSize: 17,
            },
            utilities: {
                iconSize: 0.8,
                avatarIconSize: 1,
            },
            title: {
                fontSize: 19,
            },
            column: {
                maxWidth: 300,
            },
            badge: {
                status: {
                    iconSize: 0.8,
                    fontSize: 9,
                    offsetX: 6,
                    offsetY: 6,
                },
                newMissMFC: {
                    fontSize: 9,
                    margin: 3,
                },
                priorMissMFC: {
                    altHeight: 20,
                    altWidth: 20,
                    height: 13,
                    width: 13,
                    altMargin: '1px 2px 2px 0',
                    margin: '1px 2px 2px 0',
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 4px 0 1px',
                    },
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                minimumWidth: 210,
                iconSize: 0.75,
                fontSize: 14,
                height: 28,
            },
            menu: {},
            name: {
                fontSize: adaptiveFontSize(),
                fontSizeMinimum: 14,
                height: 38,
            },
            _knownHeight: avatarKnownHeight,
        },
    },
}

export const MOBILE_AVATAR_STYLES = {
    sm: {
        default: {
            seeAll: {
                fontSize: 9.5,
            },
            utilities: {
                iconSize: 0.4,
                avatarIconSize: 0.4,
            },
            title: {
                fontSize: 15.5,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(4),
            },
            badge: {
                status: {
                    iconSize: 0.35,
                    fontSize: 6,
                    offsetX: 3,
                    offsetY: 3,
                },
                newMissMFC: {
                    compact: true,
                    fontSize: 6,
                    margin: 1,
                },
                priorMissMFC: {
                    altHeight: 10,
                    altWidth: 10,
                    height: 8.5,
                    width: 8.5,
                    altMargin: '2px 2px 2px 0px',
                    margin: '1px 2px 2px 0',
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 2px',
                    },
                    text: 'in room',
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'views/min',
                },
                new: {
                    time: {
                        margin: '0 2px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 2px',
                    },
                    text: 'MFC',
                },
                iconSize: 0.4,
                fontSize: 7,
                height: 14,
            },
            menu: {
                offsetY: -1,
            },
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 8.5, fixed: true }),
                fontSizeMinimum: 7.7,
                height: 18,
            },
            _knownHeight: avatarKnownHeight,
        },
    },
    md: {
        default: {
            seeAll: {
                fontSize: 12.5,
            },
            utilities: {
                iconSize: 0.5,
                avatarIconSize: 0.6,
            },
            title: {
                fontSize: 16,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(3),
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 7,
                    offsetX: 4,
                    offsetY: 4,
                },
                newMissMFC: {
                    fontSize: 7,
                    margin: 2,
                },
                priorMissMFC: {
                    altHeight: 14,
                    altWidth: 14,
                    height: 10,
                    width: 10,
                    altMargin: '2px 2px 2px 0px',
                    margin: '1px 2px 2px 0',
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 2px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'views/min',
                },
                new: {
                    time: {
                        margin: '0 2px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 2px',
                    },
                    text: 'MFC',
                },
                iconSize: 0.55,
                fontSize: 8,
                height: 18,
            },
            menu: {},
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 9, fixed: true }),
                fontSizeMinimum: 9.6,
                height: 22,
            },
            _knownHeight: avatarKnownHeight,
        },
    },
    lg: {
        default: {
            seeAll: {
                fontSize: 14,
            },
            utilities: {
                iconSize: 0.6,
                avatarIconSize: 0.8,
            },
            title: {
                fontSize: 17,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(2),
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 7,
                    offsetX: 5,
                    offsetY: 5,
                },
                newMissMFC: {
                    fontSize: 7,
                    margin: 3,
                },
                priorMissMFC: {
                    altHeight: 17,
                    altWidth: 17,
                    height: 11,
                    width: 11,
                    altMargin: '1px 2px 2px 0',
                    margin: '1px 2px 2px 0',
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 4px 0 2px',
                    },
                    text: 'viewers per minute',
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.6,
                fontSize: 9,
                height: 20,
            },
            menu: {},
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 9.5, fixed: true }),
                fontSizeMinimum: 14,
                height: 26,
            },
            _knownHeight: avatarKnownHeight,
        },
    },
}
